import React, { useState } from 'react';
import { Typography, Box, Link } from '@mui/material';
import { LOGIN_ACTIVATESUCCESS, LOGIN_LOGIN } from '../../constants';
import TextInputBox from '../../components/TextInputBox';
import ButtonBox from '../../components/ButtonBox';
import '../../style/Login.css';

interface ActivateAccountProps {
    setLoginPage: React.Dispatch<React.SetStateAction<string>>;
}

const ActivateAccount: React.FC<ActivateAccountProps> = ({ setLoginPage }) => {

    const [formValues, setFormValues] = useState({
        organization: '',
    });

    const handleChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormValues((prevValues) => ({ ...prevValues, [field]: e.target.value }));
    };

    const handleActivate = () => {
        setLoginPage(LOGIN_ACTIVATESUCCESS);
    };

    return (
        <>
            <Typography className='login_typography_title'>
                Activate account
            </Typography>

            <Typography className='login_typography_content'>
                You are almost there! <br />Name your organization to complete account activation.
                ben@oringnet.com will be the admin of this organization.
            </Typography>

            <TextInputBox
                label="Organization name"
                value={formValues.organization}
                onChange={handleChange('organization')}
                placeholder="Name your organization"

            />

            <ButtonBox
                text="Activate"
                onClick={handleActivate}
            />

            <Box display="flex" justifyContent="center" mt={2}>
                <Typography className='login_typography_content'>
                    Already have an acoount?{' '}
                    <Link
                        href="#"
                        color="primary"
                        underline="none"
                        onClick={() => setLoginPage(LOGIN_LOGIN)}
                    >
                        Log in
                    </Link>
                </Typography>
            </Box>
        </>
    );
};

export default ActivateAccount;
